module.exports = [{"id":"MJ","type":"MJ"},{"id":"Avocado","type":"Avocado"},{"id":"Lime","type":"Lime"},{"id":"Feijoa","type":"Feijoa"},{"id":"Garnet","type":"Garnet"},{"id":"Pepino","type":"Pepino"},{"id":"DateFruit","type":"Date fruit"},{"id":"Kiwi","type":"Kiwi"},{"id":"Strawberry","type":"Strawberry"},{"id":"Apple","type":"Apple"}]


//////////////////
// WEBPACK FOOTER
// ./src/assets/plants/plants.json
// module id = 1188
// module chunks = 0